import React from 'react';

/**
 * Inline SVG icon set for the marketing site.
 *
 * Inline rather than an icon dependency: there are a dozen of them, they
 * inherit currentColor, and they add nothing to the bundle beyond their own
 * markup. All are decorative — labelling lives on the surrounding content.
 */

const base = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

export const TapIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M9 11V6.5a1.5 1.5 0 0 1 3 0V11" />
    <path d="M12 11V9.5a1.5 1.5 0 0 1 3 0V11" />
    <path d="M15 11v-.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-1a6 6 0 0 1-5.2-3l-1.6-2.8a1.5 1.5 0 0 1 2.4-1.8L9 15" />
  </svg>
);

export const ContactIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20" />
    <circle cx="10" cy="8" r="3.5" />
    <path d="M17 11h4M19 9v4" />
  </svg>
);

export const FollowUpIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M4 7l8 6 8-6" />
  </svg>
);

export const ChartIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
  </svg>
);

export const ShieldIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3l7 3v5.5c0 4.3-2.9 8.2-7 9.5-4.1-1.3-7-5.2-7-9.5V6l7-3z" />
    <path d="M9.5 12l1.8 1.8 3.4-3.6" />
  </svg>
);

export const TeamIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 19v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1" />
    <path d="M16 5.2a3.2 3.2 0 0 1 0 5.6M17 14a4 4 0 0 1 4 4v1" />
  </svg>
);

export const CardIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="2.5" y="5.5" width="19" height="13" rx="2.2" />
    <path d="M2.5 10h19" />
    <path d="M6 14.5h4" />
  </svg>
);

export const MapPinIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 21s7-5.3 7-10.5A7 7 0 0 0 5 10.5C5 15.7 12 21 12 21z" />
    <circle cx="12" cy="10.5" r="2.5" />
  </svg>
);

export const RefreshIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M20 12a8 8 0 0 1-13.7 5.6L4 15.4" />
    <path d="M4 12a8 8 0 0 1 13.7-5.6L20 8.6" />
    <path d="M20 4v4.6h-4.6M4 20v-4.6h4.6" />
  </svg>
);

export const LockIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
    <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
  </svg>
);

export const EyeOffIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M10.6 6.2A9.6 9.6 0 0 1 12 6c5 0 9 4.4 9 6 0 .7-.8 2-2.1 3.2M6.3 8.1C4.1 9.5 3 11.3 3 12c0 1.6 4 6 9 6 1.2 0 2.3-.25 3.3-.66" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    <path d="M4 4l16 16" />
  </svg>
);

export const ListIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M9 6h12M9 12h12M9 18h12" />
    <circle cx="4.5" cy="6" r="1.2" />
    <circle cx="4.5" cy="12" r="1.2" />
    <circle cx="4.5" cy="18" r="1.2" />
  </svg>
);

export const CheckIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 12.5l5 5L20 6.5" />
  </svg>
);

export const ShopIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 8h16l-1 11a2 2 0 0 1-2 1.8H7A2 2 0 0 1 5 19L4 8z" />
    <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
  </svg>
);

export const BellIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M18 15.5V11a6 6 0 0 0-12 0v4.5L4.5 18h15L18 15.5z" />
    <path d="M10 21h4" />
  </svg>
);

export const NoteIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M5 3.5h14v17H5z" />
    <path d="M8.5 8.5h7M8.5 12h7M8.5 15.5h4" />
  </svg>
);

export const OrgChartIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="9" y="2.8" width="6" height="4.4" rx="1" />
    <rect x="2.5" y="16.8" width="5.5" height="4.4" rx="1" />
    <rect x="9.25" y="16.8" width="5.5" height="4.4" rx="1" />
    <rect x="16" y="16.8" width="5.5" height="4.4" rx="1" />
    <path d="M12 7.2v4.3M5.25 16.8v-2.6h13.5v2.6M12 14.2v2.6" />
  </svg>
);

export const NewspaperIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 5.5h13v14H5.5A1.5 1.5 0 0 1 4 18V5.5z" />
    <path d="M17 9h3v9a1.5 1.5 0 0 1-3 0" />
    <path d="M7 9h7M7 12.5h7M7 16h4" />
  </svg>
);

export const ScanIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3.5 8.5V5.5A2 2 0 0 1 5.5 3.5h3M20.5 8.5V5.5a2 2 0 0 0-2-2h-3M3.5 15.5v3a2 2 0 0 0 2 2h3M20.5 15.5v3a2 2 0 0 1-2 2h-3" />
    <path d="M3 12h18" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
    <path d="M3.5 10h17M8 3.5v3M16 3.5v3" />
    <path d="M7.5 13.5h3v3h-3z" />
  </svg>
);

export const TargetIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="4.5" />
    <circle cx="12" cy="12" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const PlayIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M10.2 8.9l5 3.1-5 3.1V8.9z" />
  </svg>
);

export const ChevronIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const SearchIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M16 16l4.5 4.5" />
  </svg>
);

export const ProfileIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="8" r="3.4" />
    <path d="M5 19.2v-.7A5.2 5.2 0 0 1 10.2 13.3h3.6A5.2 5.2 0 0 1 19 18.5v.7" />
  </svg>
);
